import { Message, PageContext, RESOLVE_KNOWLEDGE } from '../../constants/MagnusResolveAssistantConstants';

const NAVIGATION_MAP: Array<{ keywords: string[]; answer: string; target: string; label: string }> = [
    { keywords: ['fracas'], answer: 'Taking you to FRACAS...', target: '/fracas', label: 'Go to FRACAS' },
    { keywords: ['8d'], answer: 'Taking you to 8D Reports...', target: '/8d', label: 'Go to 8D' },
    { keywords: ['analytics'], answer: 'Taking you to Analytics...', target: '/analytics', label: 'Go to Analytics' },
    { keywords: ['weibull'], answer: 'Taking you to Weibull Analysis...', target: '/analytics/weibull', label: 'Go to Weibull' },
    { keywords: ['mtbf'], answer: 'Taking you to MTBF Calculator...', target: '/analytics/mtbf', label: 'Go to MTBF' },
    { keywords: ['warranty'], answer: 'Taking you to Warranty Tracking...', target: '/analytics/warranty', label: 'Go to Warranty' },
    { keywords: ['fta', 'fault tree'], answer: 'Taking you to FTA Editor...', target: '/analytics/fta', label: 'Go to FTA' },
    { keywords: ['5 why', '5-why'], answer: 'Taking you to 5-Why Analysis...', target: '/rca/5why', label: 'Go to 5-Why' },
    { keywords: ['ishikawa', 'fishbone'], answer: 'Taking you to Ishikawa Diagram...', target: '/rca/ishikawa', label: 'Go to Ishikawa' },
];

export const handleBasicQuery = (query: string, pageContext?: PageContext): { answer: string; action?: Message['action'] } => {
    const q = query.toLowerCase();

    // Navigation requests
    if (q.includes('go to') || q.includes('show me') || q.includes('navigate')) {
        const navGoal = NAVIGATION_MAP.find(nav => nav.keywords.some(k => q.includes(k)));
        if (navGoal) {
            return {
                answer: navGoal.answer,
                action: { type: 'navigate', target: navGoal.target, label: navGoal.label }
            };
        }
    }

    // Knowledge base queries
    for (const [key, value] of Object.entries(RESOLVE_KNOWLEDGE)) {
        if (q.includes(key)) {
            return { answer: `**${key.toUpperCase()}**: ${value}` };
        }
    }

    // Page-specific help
    if (pageContext && (q.includes('help') || q.includes('what') || q.includes('how'))) {
        return {
            answer: `You're on **${pageContext.name}**.\n\n${pageContext.purpose}\n\n**Next steps:**\n${pageContext.nextSteps.map((step, i) => `${i + 1}. ${step}`).join('\n')}`
        };
    }

    // Current page suggestions
    if (pageContext && pageContext.relatedPages.length > 0) {
        const page = pageContext.relatedPages[0];
        return {
            answer: `Try checking out **${page.label}** - ${page.why}`,
            action: { type: 'navigate', target: page.path, label: `Go to ${page.label}` }
        };
    }

    return {
        answer: "I'm not sure about that. Try asking:\n• 'Go to FRACAS'\n• 'What is Weibull analysis?'\n• 'Help with current page'\n• 'Show me analytics'"
    };
};
